import * as Yup from 'yup';

const passwordRules = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{5,}$/;
// min 5 characters, 1 upper case letter, 1 lower case letter, 1 numeric digit.

export const LoginSchema = (LOGIN_CONTENT) => Yup.object().shape({
    email: Yup.string().email(LOGIN_CONTENT.errors.FE102).required(LOGIN_CONTENT.errors.FE101),
    password: Yup.string().required(LOGIN_CONTENT.errors.FE103)
});

export const RegisterSchema = (REGISTRATION_CONTENT) => Yup.object().shape({
    email: Yup.string().email(REGISTRATION_CONTENT.errors.FE105).required(REGISTRATION_CONTENT.errors.FE104),
    name: Yup.string().min(3, REGISTRATION_CONTENT.errors.FE107).required(REGISTRATION_CONTENT.errors.FE106),
    company: Yup.string().required(REGISTRATION_CONTENT.errors.FE108),
    password: Yup
        .string()
        .matches(passwordRules, { message: REGISTRATION_CONTENT.errors.FE110 })
        .required(REGISTRATION_CONTENT.errors.FE109)
});

export const ForgotPasswordSchema = (FORGOT_PASSWORD_CONTENT) => Yup.object().shape({
    email: Yup.string().email(FORGOT_PASSWORD_CONTENT.errors.FE114).required(FORGOT_PASSWORD_CONTENT.errors.FE113),
});


export const ChangeYourPasswordSchema = (CHANGE_YOUR_PASSWORD_CONTENT) => Yup.object().shape({
    currentPassword: Yup
        .string()
        .required(CHANGE_YOUR_PASSWORD_CONTENT.errors.FE118),
    newPassword: Yup
        .string()
        .matches(passwordRules, { message: CHANGE_YOUR_PASSWORD_CONTENT.errors.FE120 })
        .required(CHANGE_YOUR_PASSWORD_CONTENT.errors.FE119),
    confirmPassword: Yup
        .string()
        .oneOf([Yup.ref("newPassword"), null], CHANGE_YOUR_PASSWORD_CONTENT.errors.FE122)
        .required(CHANGE_YOUR_PASSWORD_CONTENT.errors.FE121),
});

export const DeactivateYourAccountSchema = (DEACTIVATE_YOUR_ACCOUNT) => Yup.object().shape({
    password: Yup
        .string()
        .required(DEACTIVATE_YOUR_ACCOUNT.errors.FE123),
});

export const DeactivateYourCompanySchema = (DEACTIVATE_YOUR_COMPANY) => Yup.object().shape({
    password: Yup
        .string()
        .required(DEACTIVATE_YOUR_COMPANY.errors.FE125),
});

export const DeactivateAccountSchema = (DEACTIVATE_ACCOUNT_MODAL) => Yup.object().shape({
    email: Yup
        .string()
        .required(DEACTIVATE_ACCOUNT_MODAL.errors.FE126),
});

export const InviteUserFormSchema = (INVITE_USER_MODAL) => Yup.object().shape({
    name: Yup.string().min(3, INVITE_USER_MODAL.errors.FE130).required(INVITE_USER_MODAL.errors.FE129),
    email: Yup.string().email(INVITE_USER_MODAL.errors.FE128).required(INVITE_USER_MODAL.errors.FE127),
    organizationRole: Yup.string().required(INVITE_USER_MODAL.errors.FE131),
});

export const SaveTaskFormSchema = (SAVE_TASK_MODAL_CONTENT) => Yup.object().shape({
    name: Yup.string().min(3, SAVE_TASK_MODAL_CONTENT.errors.FE130).required(SAVE_TASK_MODAL_CONTENT.errors.FE129),
});

export const NewIntegrationFormSchema = (NEW_INTEGRATION_CONTENT) => Yup.object().shape({
    integration_name: Yup.string().required(NEW_INTEGRATION_CONTENT.errors.FE134),
    client_key: Yup.string().required(NEW_INTEGRATION_CONTENT.errors.FE135),
    x_api_key: Yup.string().required(NEW_INTEGRATION_CONTENT.errors.FE136),
    scope: Yup.string().required(NEW_INTEGRATION_CONTENT.errors.FE142),
    client_name: Yup.string(),
    tenant_name: Yup.string(),
    organization_name: Yup.string().required(NEW_INTEGRATION_CONTENT.errors.FE139),
    technical_account_id: Yup.string().required(NEW_INTEGRATION_CONTENT.errors.FE140),
    technical_account_email: Yup.string().email(NEW_INTEGRATION_CONTENT.errors.FE143).required(NEW_INTEGRATION_CONTENT.errors.FE141),
    products: Yup.array().min(1, NEW_INTEGRATION_CONTENT.errors.FE144).required(NEW_INTEGRATION_CONTENT.errors.FE145),
});

export const NewIntegrationFormSchemaWithAdobe = (NEW_INTEGRATION_CONTENT) => Yup.object().shape({
    integration_name: Yup.string().required(NEW_INTEGRATION_CONTENT.errors.FE134),
    client_key: Yup.string().required(NEW_INTEGRATION_CONTENT.errors.FE135),
    x_api_key: Yup.string().required(NEW_INTEGRATION_CONTENT.errors.FE136),
    scope: Yup.string().required(NEW_INTEGRATION_CONTENT.errors.FE142),
    client_name: Yup.string().required(NEW_INTEGRATION_CONTENT.errors.FE137),
    tenant_name: Yup.string().required(NEW_INTEGRATION_CONTENT.errors.FE138),
    organization_name: Yup.string().required(NEW_INTEGRATION_CONTENT.errors.FE139),
    technical_account_id: Yup.string().required(NEW_INTEGRATION_CONTENT.errors.FE140),
    technical_account_email: Yup.string().email(NEW_INTEGRATION_CONTENT.errors.FE143).required(NEW_INTEGRATION_CONTENT.errors.FE141),
    products: Yup.array().min(1, NEW_INTEGRATION_CONTENT.errors.FE144).required(NEW_INTEGRATION_CONTENT.errors.FE145),
});

export const NewTealiumIntegrationFormSchema = (NEW_TEALIUM_INTEGRATION_CONTENT) => Yup.object().shape({
    tealium_account: Yup.string().required(NEW_TEALIUM_INTEGRATION_CONTENT.errors.FE134),
    tealium_api_name: Yup.string().required(NEW_TEALIUM_INTEGRATION_CONTENT.errors.FE135),
    tealium_key: Yup.string().required(NEW_TEALIUM_INTEGRATION_CONTENT.errors.FE136),
    tealium_profile: Yup.string().required(NEW_TEALIUM_INTEGRATION_CONTENT.errors.FE137),
    tealium_user: Yup.string().required(NEW_TEALIUM_INTEGRATION_CONTENT.errors.FE138),
});

export const NewAEMAdobeIOFormSchema = (NEW_AEM_ADOBE_IO_CONTENT) => Yup.object().shape({
    aem_adobe_io_name: Yup.string().required(NEW_AEM_ADOBE_IO_CONTENT.errors.FE134),
    imsEndpoint: Yup.string().required(NEW_AEM_ADOBE_IO_CONTENT.errors.FE135),
    metascopes: Yup.string().required(NEW_AEM_ADOBE_IO_CONTENT.errors.FE136),
    clientId: Yup.string().required(NEW_AEM_ADOBE_IO_CONTENT.errors.FE137),
    clientSecret: Yup.string().required(NEW_AEM_ADOBE_IO_CONTENT.errors.FE138),
    email: Yup.string().required(NEW_AEM_ADOBE_IO_CONTENT.errors.FE139),
    id: Yup.string().required(NEW_AEM_ADOBE_IO_CONTENT.errors.FE140),
    org: Yup.string().required(NEW_AEM_ADOBE_IO_CONTENT.errors.FE141),
    privateKey: Yup.string().required(NEW_AEM_ADOBE_IO_CONTENT.errors.FE142),
    publicKey: Yup.string().required(NEW_AEM_ADOBE_IO_CONTENT.errors.FE143),
    certificateExpirationDate: Yup.string().required(NEW_AEM_ADOBE_IO_CONTENT.errors.FE144),
    author_api_url: Yup.string().required(NEW_AEM_ADOBE_IO_CONTENT.errors.FE145),
});

export const NewContentfulIntegrationSchema = (NEW_CONTENTFUL_CONTENT) => Yup.object().shape({
    name: Yup.string().required(NEW_CONTENTFUL_CONTENT.errors.FE134),
    space_id: Yup.string().required(NEW_CONTENTFUL_CONTENT.errors.FE135),
    content_delivery_access_token: Yup.string().required(NEW_CONTENTFUL_CONTENT.errors.FE136),
    content_preview_access_token: Yup.string().required(NEW_CONTENTFUL_CONTENT.errors.FE137),
    environments: Yup.string().required(NEW_CONTENTFUL_CONTENT.errors.FE138),
    cma_token: Yup.string().required(NEW_CONTENTFUL_CONTENT.errors.FE141),
}); // wrong error message

export const NewGithubIntegrationSchema = (NEW_CONTENTFUL_CONTENT) => Yup.object().shape({
    name: Yup.string().required("Name is required."),
    access_token: Yup.string().required("Access is required."),
    repo_name: Yup.string().required("Repository name is required."),
    repo_owner_username: Yup.string().required("Repository owner username is required."),
    branch_name: Yup.string().required("Branch name is required."),
    file_extensions: Yup.array().min(1, "At least one file extension is required.")
});

export const NewTealiumAudienceIntegrationFormSchema = (CREATE_NEW_TEALIUM_AUDIENCE_STREAM) => Yup.object().shape({
    tealium_as_audience_id: Yup.string().required(CREATE_NEW_TEALIUM_AUDIENCE_STREAM.errors.FE134),
    tealium_as_audience_name: Yup.string().required(CREATE_NEW_TEALIUM_AUDIENCE_STREAM.errors.FE135),
    at_audience_id: Yup.string().required(CREATE_NEW_TEALIUM_AUDIENCE_STREAM.errors.FE136),
    at_audience_name: Yup.string().required(CREATE_NEW_TEALIUM_AUDIENCE_STREAM.errors.FE137),
    at_audience_workspace: Yup.string().required(CREATE_NEW_TEALIUM_AUDIENCE_STREAM.errors.FE138),
});

export const AddSMTPTaskSchema = (VALIDATE_SMTP_CONTENT) => Yup.object().shape({
    saved_task_name: Yup.string().matches(/^[\.\-_A-Za-z0-9]+$/, {
        message: VALIDATE_SMTP_CONTENT.errors.FE133
    }).required(VALIDATE_SMTP_CONTENT.errors.FE134),
    time_interval: Yup.string().required(VALIDATE_SMTP_CONTENT.errors.FE135),
    status: Yup.string().required(VALIDATE_SMTP_CONTENT.errors.FE136),
    email: Yup.string().email(VALIDATE_SMTP_CONTENT.errors.FE137),
    recipient_emails: Yup.array().min(1, VALIDATE_SMTP_CONTENT.errors.FE138).of(Yup.string().required())
});

export const AddNameTaskSchema = (VALIDATE_NAME_CONTENT) => Yup.object().shape({
    saved_task_name: Yup.string().matches(/^[\.\-_A-Za-z0-9]+$/, {
        message: VALIDATE_NAME_CONTENT.errors.FE133
    }).required(VALIDATE_NAME_CONTENT.errors.FE134),
    time_interval: Yup.string().required(VALIDATE_NAME_CONTENT.errors.FE135),
    status: Yup.string().required(VALIDATE_NAME_CONTENT.errors.FE136),
    regex: Yup.string().test('is-regex', VALIDATE_NAME_CONTENT.errors.FE140, (value) => {
        try {
            new RegExp(value);
            return true;
        } catch (err) {
            return false;
        }
    }),
    email: Yup.string().email(VALIDATE_NAME_CONTENT.errors.FE137),
    recipient_emails: Yup.array().min(1, VALIDATE_NAME_CONTENT.errors.FE138).of(Yup.string().required())
});

export const AddActivityNameTaskSchema = (VALIDATE_NAME_CONTENT) => Yup.object().shape({
    saved_task_name: Yup.string().matches(/^[\.\-_A-Za-z0-9]+$/, {
        message: VALIDATE_NAME_CONTENT.errors.FE133
    }).required(VALIDATE_NAME_CONTENT.errors.FE134),
    time_interval: Yup.string().required(VALIDATE_NAME_CONTENT.errors.FE135),
    status: Yup.string().required(VALIDATE_NAME_CONTENT.errors.FE136),
    regex: Yup.string().test('is-regex', VALIDATE_NAME_CONTENT.errors.FE140, (value) => {
        try {
            new RegExp(value);
            return true;
        } catch (err) {
            return false;
        }
    }),
    adobe_io_integration_id: Yup.string().required("Adobe IO integration is required"),
    filter_value: Yup.string().required(VALIDATE_NAME_CONTENT.errors.FE141),
    email: Yup.string().email(VALIDATE_NAME_CONTENT.errors.FE137),
    recipient_emails: Yup.array().min(1, VALIDATE_NAME_CONTENT.errors.FE138).of(Yup.string().required())
});

export const AdobeTargetActivitiesRevisionsSchema = (VALIDATE_NAME_CONTENT) => Yup.object().shape({
    saved_task_name: Yup.string().matches(/^[\.\-_A-Za-z0-9]+$/, {
        message: VALIDATE_NAME_CONTENT.errors.FE133
    }).required(VALIDATE_NAME_CONTENT.errors.FE134),
    time_interval: Yup.string().required(VALIDATE_NAME_CONTENT.errors.FE135),
    status: Yup.string().required(VALIDATE_NAME_CONTENT.errors.FE136),
    adobe_io_integration_id: Yup.string().required("Adobe IO integration is required"),
    email: Yup.string().email(VALIDATE_NAME_CONTENT.errors.FE137),
    recipient_emails: Yup.array().min(1, VALIDATE_NAME_CONTENT.errors.FE138).of(Yup.string().required())
});

export const GithubExperienceSyncSchema = (GITHUB_EXPERIENCE_SYNC_CONTENT) =>
    Yup.object().shape({
        saved_task_name: Yup.string().matches(/^[\.\-_A-Za-z0-9]+$/, {
            message: GITHUB_EXPERIENCE_SYNC_CONTENT.errors.FE201
        }).required(GITHUB_EXPERIENCE_SYNC_CONTENT.errors.FE202),
        github_integration_id: Yup.string().required(
            GITHUB_EXPERIENCE_SYNC_CONTENT.errors.FE203
        ),
        status: Yup.string().required(
            GITHUB_EXPERIENCE_SYNC_CONTENT.errors.FE204
        ),
    });

export const createAtAudienceFromTealiumTaskSchema = (CREATE_AT_AUDIENCE_FROM_TEALIUM_CONTENT) => Yup.object().shape({
    saved_task_name: Yup.string().matches(/^[\.\-_A-Za-z0-9]+$/, {
        message: CREATE_AT_AUDIENCE_FROM_TEALIUM_CONTENT.errors.FE133
    }).required(CREATE_AT_AUDIENCE_FROM_TEALIUM_CONTENT.errors.FE134),
    time_interval: Yup.string().required(CREATE_AT_AUDIENCE_FROM_TEALIUM_CONTENT.errors.FE135),
    status: Yup.string().required(CREATE_AT_AUDIENCE_FROM_TEALIUM_CONTENT.errors.FE136),
    adobe_io_integration_id: Yup.string().required("Adobe IO integration is required"),
    tealium_integration_id: Yup.string().required("Tealium integration is required"),
    domains_list: Yup.array().min(1, "At least one domain is required").of(Yup.string().required()),
    custom_parameters: Yup.array().min(1, "At least one custom parameter is required").of(Yup.string().required()),
    email: Yup.string().email(CREATE_AT_AUDIENCE_FROM_TEALIUM_CONTENT.errors.FE137),
    recipient_emails: Yup.array().min(1, CREATE_AT_AUDIENCE_FROM_TEALIUM_CONTENT.errors.FE138).of(Yup.string().required())
});

export const tealiumDataLayerRepositorySchema = (messages) => Yup.object().shape({
    saved_task_name: Yup.string().matches(/^[\.\-_A-Za-z0-9]+$/, {
        message: messages.saved_task_name_invalid || "Task name can only contain letters, numbers, dots, hyphens, and underscores"
    }).required(messages.saved_task_name_required || "Task name is required"),
    domains: Yup.string().required(messages.domains || "Domain is required"),
    custom_parameters: Yup.array().of(
        Yup.object().shape({
            key: Yup.string().required(),
            visibility: Yup.boolean()
        })
    ),
});

export const activateTealiumAudienceSchema = (massages) => Yup.object({
    name: Yup.string().required(massages.errors.FE134),
    notes: Yup.string().required(massages.errors.FE135),
});

export const TargetOfferSchema = Yup.object().shape({
    offer_name: Yup
        .string()
        .required("Offer name is required"),
});

export const TargetExperienceSchema = Yup.object().shape({
    experience_name: Yup
        .string()
        .required("Experience name is required"),
});


const namingConventionValidation = (ADOBE_TARGET_AUDIENCE_CONFIG_RULE_INPUT) => Yup.string()
    .required(ADOBE_TARGET_AUDIENCE_CONFIG_RULE_INPUT.errors.FE136)
    .test(
        'includes-valid-placeholders_values',
        'AS_AUDIENCE_ID_FULL, AS_AUDIENCE_ID_NUMERIC, AS_AUDIENCE_NAME should be wrapped with {{ }}',
        value => {
            if (!value) return false;

            const invalidPlaceholdersPattern = /\{\{[^{}]*?\}\}|\{[^{}]*?\}/g;
            const mt = value.match(invalidPlaceholdersPattern);

            if (!mt) {
                return false;
            }
            return true;
        }
    )
    .test(
        'includes-valid-placeholders_values',
        'AS_AUDIENCE_ID_FULL, AS_AUDIENCE_ID_NUMERIC, AS_AUDIENCE_NAME should be wrapped with {{ }} not with empty { } or {{ }}',
        value => {
            if (!value) return false;

            // Check for any invalid placeholders
            const validDoublePlaceholders = ['{{AS_AUDIENCE_ID_FULL}}', '{{AS_AUDIENCE_ID_NUMERIC}}', '{{AS_AUDIENCE_NAME}}'];
            const invalidPlaceholdersPattern = /\{\{[^{}]*?\}\}|\{[^{}]*?\}/g;
            const mt = value.match(invalidPlaceholdersPattern);
            const allDoubleValValid = mt && mt.every(placeholder => validDoublePlaceholders.includes(placeholder));

            if (!allDoubleValValid) {
                return false;
            }
            return true;
        }
    )

export const workspaceValidation = (WORKSPACE_MANAGEMENT_CONTENT) => Yup.object().shape({
    workspace_id: Yup.string().required(WORKSPACE_MANAGEMENT_CONTENT.error.EE134),
    workspace_name: Yup.string().required(WORKSPACE_MANAGEMENT_CONTENT.error.EE135),
});

export const ATAudienceConfigRule = (ADOBE_TARGET_AUDIENCE_CONFIG_RULE_INPUT) => Yup.object().shape({
    mbox_parameter_name: Yup.string().required(ADOBE_TARGET_AUDIENCE_CONFIG_RULE_INPUT.errors.FE134),
    comparison_rule: Yup.string().required(ADOBE_TARGET_AUDIENCE_CONFIG_RULE_INPUT.errors.FE135),
    naming_convention: namingConventionValidation(ADOBE_TARGET_AUDIENCE_CONFIG_RULE_INPUT),
});

export const importTemplateFromFigmaSchema = () => Yup.object().shape({
    figma_url: Yup.string().url("Invalid Figma URL").required("Figma URL is required"),
    figma_access_token: Yup.string().required("Figma Access Token is required"),
});

export const UpdateAdobeTargetAudienceSchema = (UPDATE_ADOBE_TARGET_AUDIENCE_MODAL_CONTENT) => Yup.object().shape({
    at_audience_name: Yup.string().required(UPDATE_ADOBE_TARGET_AUDIENCE_MODAL_CONTENT.errors.FE138),
    at_audience_id: Yup.string().required(UPDATE_ADOBE_TARGET_AUDIENCE_MODAL_CONTENT.errors.FE139),
    as_audience_name: Yup.string().required(UPDATE_ADOBE_TARGET_AUDIENCE_MODAL_CONTENT.errors.FE140),
    as_audience_id: Yup.string().required(UPDATE_ADOBE_TARGET_AUDIENCE_MODAL_CONTENT.errors.FE141),
    mbox_parameter_name: Yup.string().required(UPDATE_ADOBE_TARGET_AUDIENCE_MODAL_CONTENT.errors.FE142),
    comparison_rule: Yup.string().required(UPDATE_ADOBE_TARGET_AUDIENCE_MODAL_CONTENT.errors.FE143)
});

export const createOrganizationSchema = (ORGANIZATION) => Yup.object({
    orgName: Yup.string().required(ORGANIZATION.error.FE131),
    displayName: Yup.string().required(ORGANIZATION.error.FE132),
    level: Yup.string().required(ORGANIZATION.error.FE133),
});

const emailPattern = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;

export const notificationSchema = Yup.object().shape({
    type: Yup.string()
        .required('Type is required')
        .oneOf(['global'], 'Invalid type'),
    title: Yup.string()
        .required('Title is required')
        .max(100, 'Title cannot exceed 100 characters'),
    description: Yup.string()
        .required('Description is required')
        .max(500, 'Description cannot exceed 500 characters'),
    deep_link: Yup.string()
        .required('Deep link is required')
        .url('Must be a valid URL'),
    category: Yup.string()
        .required()
        .max(100, 'Category cannot exceed 100 characters'),
    is_email_required: Yup.boolean(),
    email_recipients: Yup.array()
        .of(Yup.string().matches(emailPattern, 'Invalid email format'))
        .test('is-array', 'Email recipients must be an array', value => Array.isArray(value))
});

export const releaseSchema = Yup.object({
    version: Yup.string().required('Version is required'),
    release_date: Yup.date().required('Release date is required'),
    status: Yup.string().required('Status is required'),
    notification_configuration: Yup.object({
        pre_release: Yup.array().of(
            Yup.object({
                title: Yup.string().required('Title is required'),
                description: Yup.string().required('Description is required'),
                schedule_time_before_release: Yup.string().required('Schedule time before release is required'),
                is_email_required: Yup.boolean(),
                email_recipients: Yup.array()
                    .of(Yup.string().matches(emailPattern, 'Invalid email format'))
                    .test('is-array', 'Email recipients must be an array', value => Array.isArray(value))
            })
        ),
        post_release: Yup.array().of(
            Yup.object({
                title: Yup.string().required('Title is required'),
                description: Yup.string().required('Description is required'),
                schedule_time_after_release: Yup.string().required('Schedule time before release is required'),
                is_email_required: Yup.boolean(),
                email_recipients: Yup.array()
                    .of(Yup.string().matches(emailPattern, 'Invalid email format'))
                    .test('is-array', 'Email recipients must be an array', value => Array.isArray(value))
            })
        )
    })
});

export const planSchema = Yup.object().shape({
    plan_name: Yup.string().required("Plan name is required"),
    plan_description: Yup.string().required("Plan description is required"),
    org_level: Yup.string().when('is_topup', {
        is: false,
        then: (schema) => schema.required("Organization level is required"),
        otherwise: (schema) => schema.notRequired()
    }),
    price: Yup.number()
      .typeError("Price must be a number")
      .min(0, "Price must be 0 or more")
      .required("Price is required"),
    price_currency: Yup.string().required("Currency is required"),
    discount: Yup.number().typeError("Discount must be a number").min(0, "Discount cannot be negative").nullable(),
    duration: Yup.number()
      .typeError("Duration must be a number")
      .when('is_topup', {
          is: false,
          then: (schema) => schema.positive("Duration must be positive")
                                  .integer("Duration must be a whole number")
                                  .required("Duration is required"),
          otherwise: (schema) => schema.nullable().notRequired()
      }),
    is_custom_plan: Yup.boolean().required("Please select if this is a custom plan"),
    is_topup: Yup.boolean().required("Please select if this is a topup plan"),
    ai_credits_limit: Yup.number()
        .typeError("AI Credits Limit must be a number")
        .min(0, "AI Credits Limit must be 0 or more")
        .nullable(),
    ai_margin_percent: Yup.number()
        .typeError("AI Margin Percent must be a number")
        .min(0, "AI Margin Percent must be 0 or more")
        .max(100, "AI Margin Percent cannot exceed 100")
        .nullable(),
  })

export const orgPlanMappingSchema = Yup.object().shape({
    org_id: Yup.string()
        .required("Organization ID is required"),
    plan_id: Yup.string()
        .required("Plan ID is required"),
    start_date: Yup.date()
        .required("Start date is required")
        .nullable(),
    end_date: Yup.date()
        .required("End date is required")
        .nullable()
        .min(Yup.ref('start_date'), "End date must be after start date"),
    is_active: Yup.boolean()
});